export default "__VITE_ASSET__YSt8I$go__"